export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.1fe474e3.eot";